import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import SendMoneyService from "../../services/send-money.service";
import { useNavigate } from "react-router";
import Loader from "../../components/loader";
import { Button, Card, Empty, Modal } from "antd";
import { AiFillStar, AiOutlineDelete, AiOutlineStar } from "react-icons/ai";
import { useSelector } from "react-redux";
import {
  accountListSelector,
  modeSelector,
} from "../../store/selectors/app.selector";
import { PatternFormat } from "react-number-format";
import {ReactComponent as TickIcon} from "../../assests/images/tickIcon.svg";
import defaultUser from "../../assests/images/defaultuser.svg";
import { useTranslation } from "react-i18next";
export default function OwnAccountList() {
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const accountList = useSelector(accountListSelector);
  const [favType, setFavType] = useState("");
  const mode = useSelector(modeSelector);
  const { t } = useTranslation();
  // useEffect(() => {
  //   getAllPayee();
  // }, []);

  // const getAllPayee = useCallback(async () => {
  //   try {
  //     setLoader(true);
  //     const response = await SendMoneyService.getFavouriteList();
  //     if (response.status === 200) {
  //       setLoader(false);
  //       // const accountListCopy = [...accountList];
  //       // accountListCopy.forEach((element) => {
  //       //   element.favourite = false;
  //       // });
  //       // if (response.data["data"]["accountList"]?.length > 0) {
  //       //   response.data["data"]["accountList"].forEach((ele) => {
  //       //     accountListCopy.forEach((element) => {
  //       //       if (ele.acctNo === element.acctNo) {
  //       //         element.favourite = ele.favAccount;
  //       //       }
  //       //     });
  //       //   });
  //       //   setDataSource(accountListCopy || []);
  //       // } else {
  //       setDataSource(response.data["data"]["accountList"]);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //   }
  // }, [accountList]);

  return (
    <>
      <div className="dashboard-accounts-wrapper row">
        {noRecords && (
          <div>
            <Empty description="No Beneficiaries Found" />
          </div>
        )}

        {accountList.map((option, idx) => (
          <div key={idx} className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <Card
              className="transfercard mb-2"
              align="center"
              onClick={() =>
                navigate("/send-money/payee-transfer/own", {
                  state: { ...option, mode: "PAY_LIST" },
                })
              }
            >
              <div className="mt-2">
                <img src={defaultUser} alt={option.accountNo} height={30} />
              </div>
              <div className="mt-2">
                <span
                className="transfercardspan"
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {option.accountNo}
                </span>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </>
  );
}
